import React, { useEffect, useMemo, useState } from "react";
import { Box } from '@mui/joy';
import { sha1Hex } from 'src/mtska-frontend-modules/modules/_shared/crypto/sha1Hex';

const FleetManagerIframe = ({ }) => {
    const thirdLevel = useMemo(() => {
        const url = window.location.href;
        const parts = new URL(url).hostname.split(".");
        return parts.length > 2 ? parts.slice(0, -2).join(".") : 'demo';
    }, []);

    const [iframeSrc, setIframeSrc] = useState('');

    useEffect(() => {
        let cancelled = false;

        (async () => {
            let segment = thirdLevel;
            if (typeof crypto !== 'undefined' && crypto.subtle) {
                try {
                    segment = await sha1Hex(thirdLevel);
                } catch {
                    segment = thirdLevel;
                }
            }
            if (!cancelled) {
                setIframeSrc(`https://fleetservices.myfleetsolution.it/${segment}/kpis`);
            }
        })();

        return () => {
            cancelled = true;
        };
    }, [thirdLevel]);

    return (
        <Box className="dashboard-menu dashboard-menu-1col" sx={{ aspectRatio: '4/3', width:"100%"}} data-src={thirdLevel}>
            {iframeSrc ? (
                <iframe style={{width:"100%", aspectRatio: '4/3',  border:'1px solid var(--app-surface-subdued)',borderRadius:'10px',boxShadow:'0 0 50px rgba(0,0,0,0.12)', overflow:'hidden', display: "block"}} src={iframeSrc} scrolling="no" title="Fleet KPIs"></iframe>
            ) : null}
        </Box>
    );
};

export default FleetManagerIframe;
